import { Col, Icon, notification, Row, Select, Tooltip } from "antd";
import { MenuOutlined } from "@ant-design/icons"; // Import the icon from Ant Design's icons package
import React, { useEffect, useState } from "react";
import {
  ArrowDownIcon,
  InfoIcon,
  CustomTriangleInfoIcon,
  CloseIcon,
} from "../../common/CustomIcon";
import zIndex from "@mui/material/styles/zIndex";
const { Option, OptGroup } = Select;

const Select_v2 = (props) => {
  const {
    options,
    value: propValue,
    onChange,
    style,
    isMultiple=false,
    className,
    labelField,
    valueField,
    showSelectOption,
    defaultValuePlaceholder,
    placeholder,
    icon,
    loading = false,
    showSearch = true,
    is_account = false,
    creditsExceededAccnts,
   selectedOption,
   codeField = "",
   accInputRef = null,
    // Optional grouping: when groupField is set and at least one option carries a
    // truthy option[groupField], the (non-account) options render inside antd
    // OptGroups keyed by that value. Ungrouped options fall under defaultGroupLabel.
    // Fully backward-compatible: unset groupField => flat list as before.
    groupField = "",
    defaultGroupLabel = "Other",
    suffixIcon = <ArrowDownIcon />,
    wrapperClassName = "",
    wrapperStyle,
    ...restProps
  } = props;
  const [value, setValue] = useState(propValue);

  useEffect(() => {
    setValue(propValue);
    if (accInputRef?.current) {
    accInputRef.current.value = propValue;
  }
  }, [propValue]);
  const handleChange = (val) => {
    const selectedOption = options.find((option) => option[valueField] === val);
    if (is_account && selectedOption && creditsExceededAccnts.includes(selectedOption.code)) {
      openNotification();
      setValue("");
      onChange("", null);
      if (accInputRef?.current)
      accInputRef.current.value = "";
      return;
    }
    setValue(val);
    onChange(val,selectedOption);
    if (accInputRef?.current)
    accInputRef.current.value = val;
  };

  // Default styles
  const defaultStyle = {
    width: "100%",
    ...style, // Merges passed styles with default styles
  };
  const customStyle = {
    width: "100%", // Ensure full width
    height: "24px", // Set fixed height for dropdown
    padding: "0", // Remove default padding
    ...style, // Merge custom styles
  };

  const openNotification = () => {
    notification.info({
      message: "Exceeded Limit",
      description: "Exceeded limit, selection not allowed.",
      icon: <CustomTriangleInfoIcon />,
      placement: "bottomLeft", // choose preferred placement
      closeIcon: <CloseIcon />,
      className: "custom-notification",
    });
  };
const toolTipText = "Exceeded limit, selection not allowed.";
  return (
    <div
      className={wrapperClassName ? `select_v2 ${wrapperClassName}` : "select_v2"}
      style={{ display: "block", width: "100%", minWidth: 0, ...wrapperStyle }}
    >
      <Select
        suffixIcon={suffixIcon}
        mode={isMultiple ? "multiple" : "single" }
        // prefixIcon={<Icon type="caret-down" />}
        style={defaultStyle}
        value={value}
        className={className}
        onChange={handleChange}
        placeholder={placeholder || "Select an option"}
        loading={loading}
        ref={accInputRef}
        showSearch={showSearch}
        filterOption={(input, option) => {
          const matchingOption = options.find((opt) => opt[valueField] === option.key);

          const label = matchingOption ? matchingOption[labelField] : null;
          const code = matchingOption ? matchingOption[codeField] : null;

          const labelText = typeof label === "string" ? label : "";
          return (code && code.toLowerCase().includes(input.toLowerCase())) || (labelText && labelText.toLowerCase().includes(input.toLowerCase()));
        }}
        {...restProps}
      >
        {/* Render options fro,m props */}
        {showSelectOption && (
          <Option key="SELECT" style={{ marginTop: 4 }} value="">
            {defaultValuePlaceholder}
          </Option>
        )}
        {!is_account
          ? (() => {
              const renderLosOption = (option) => (
                <Option key={option[valueField]} value={option[valueField]}>
                  <Row gutter={10} type="flex" justify="start" align="middle">
                    {option.icon && <Col>{option.icon}</Col>}
                    {!option.icon && icon && <Col>{icon}</Col>}
                    {codeField ? <Col>{option[labelField]} ({option[codeField]})</Col> : <Col>{option[labelField]}</Col>}
                  </Row>
                </Option>
              );
              if (groupField && options.some((o) => o[groupField])) {
                const order = [];
                const byLabel = {};
                options.forEach((o) => {
                  const label = o[groupField] || defaultGroupLabel;
                  if (!byLabel[label]) { byLabel[label] = []; order.push(label); }
                  byLabel[label].push(o);
                });
                return order.map((label) => (
                  <OptGroup key={label} label={label}>
                    {byLabel[label].map(renderLosOption)}
                  </OptGroup>
                ));
              }
              return options.map(renderLosOption);
            })()
          : options.map((option) => (
              <Option key={option[valueField]} value={option[valueField]}>
                <Row
                  gutter={10}
                  type="flex"
                  justify="space-between"
                  align="middle"
                >
                  {option.icon && <Col>{option.icon}</Col>}
                  {!option.icon && icon && <Col>{icon}</Col>}
                  <Col>{option[labelField]}-{option[codeField]}</Col>
                  {creditsExceededAccnts.includes(option.code) && (
                    <Tooltip 
                      placement="left"
                      title={toolTipText} 
                      overlayStyle={{zIndex: 999}}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    >
                      <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
                        <InfoIcon
                          width="24px"
                          height="24px"
                          className="info-icon"
                        />
                      </span>
                    </Tooltip>
                  )}
                </Row>
              </Option>
            ))}
      </Select>
    </div>
  );
};

Select_v2.defaultProps = {
  defaultValuePlaceholder: "--Select--",
  value: "",
  icon: "", // Use the new Ant Design Icon
  onChange: () => {},
  size: "small",
  disabled: false,
  valueField: "id",
  labelField: "name",
  showSelectOption: false,
  creditsExceededAccnts: [],
};

export default Select_v2;
